"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentStatusBadge = void 0;
const shipment_status_badge_component_1 = require("./shipment-status-badge/shipment-status-badge.component");
Object.defineProperty(exports, "ShipmentStatusBadge", { enumerable: true, get: function () { return shipment_status_badge_component_1.ShipmentStatusBadge; } });
